/**
 * reload/element action=reloadPage нужен только ленивой вкладке.
 * Пустые Tiles на обычной странице — валидные данные, не повод подгружать page.
 */
export function isLazyFormPage(form: unknown, pageId: unknown): boolean {
  const wanted = String(pageId ?? '').trim()
  if (!wanted || !form || typeof form !== 'object') return false

  let found: boolean | undefined
  const visit = (node: unknown) => {
    if (found !== undefined || node == null || typeof node !== 'object') return
    if (Array.isArray(node)) {
      for (const item of node) visit(item)
      return
    }
    const rec = node as Record<string, unknown>
    const attrs = rec._attributes as { id?: unknown } | undefined
    const id = rec.id ?? attrs?.id
    const pageLike = Array.isArray(rec.panelRows)
    if (id != null && String(id) === wanted && pageLike) {
      const flag = rec.lazy
      found = flag === true || flag === 'true'
      return
    }
    for (const value of Object.values(rec)) visit(value)
  }
  visit(form)
  return found === true
}
